import React, { useState, useEffect } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import ReactTable from 'components/ReactTable/ReactTable';
import { nPercent, nDecimal } from 'hooks/Pipe';
import FilterArticle from 'hooks/FilterArticle';
import { wsGet, wsFindBy } from 'services/WService';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 50 },

  { Header: 'Zona', accessor: 'zone_description', width: 150 },
  { Header: 'Lista Precio', accessor: 'ListName', width: 150 },
  { Header: 'Proveedor', accessor: 'CardName', width: 200 },
  { Header: 'Categoría', accessor: 'category_description', width: 150 },
  { Header: 'Línea', accessor: 'line_description', width: 150 },
  { Header: 'Família', accessor: 'family_description', width: 150 },
  { Header: 'Cod. Producto', accessor: 'ItemCode', width: 150 },
  { Header: 'Producto', accessor: 'ItemName', width: 200 },
  { Header: 'Últ.Pre.Com.', accessor: 'last_purchase_price', width: 120 },
  { Header: 'Pre.Unidad', accessor: 'unit_price', width: 120 },
  { Header: 'Margen Unidad', accessor: 'unit_margin', width: 140 },
  { Header: 'Pre.paquete', accessor: 'package_price', width: 120 },
  { Header: 'MargenPaquete', accessor: 'package_margin', width: 140 },
  { Header: 'Stock físico', accessor: 'OnHand', width: 120 },

  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

function NegativeMargins() {
  const [margins, setMargins] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);

  useEffect(() => {
    wsGet('logi/negative-margin').then((res) => {
      setMargins(res.data);
    });
  }, []);

  async function loadMargins(filter) {
    setDataLoading(true);
    let res = await wsFindBy('logi/negative-margin', filter);
    setDataLoading(false);
    if (res.success) {
      setMargins(res.data);
    }
  }

  return (
    <CardContainer /*title="Listado de productos con margenes negativos"*/ title={(<>Listado de productos con margenes negativos {dataLoading && <LoadingSpinner />}</>)}>
      <FilterArticle getFilter={loadMargins} article zone />

      <ReactTable
        columns={columns}
        data={margins.map((item, i) => {
          return {
            ...item,
            num: i + 1,
            last_purchase_price: item.last_purchase_price,
            unit_price: nDecimal(item.unit_price),
            unit_margin: nPercent(item.unit_margin),
            package_price: nDecimal(item.package_price),
            package_margin: nPercent(item.package_margin),
            OnHand: parseInt(item.OnHand),
          };
        })}
      />
    </CardContainer>
  );
}

export default NegativeMargins;
